import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { colours } from "../../../StyleConstants";
import LassoModal from "../../../components/LassoModal";
import React, { useState } from "react";
import { useRevokeUserMutation } from "../../../api/userApiSlice";
import { setNewNotification } from "../../common/notificationSlice";
import { useDispatch } from "react-redux";

interface modalProps {
    open: boolean,
    setOpen: Function,
    username: string
    email: string
}

const UserActionConfirm = (props: modalProps) => {
    const [revoke] = useRevokeUserMutation({});
    const dispatch = useDispatch();
    const [loading,setLoading] = useState(false)

    const handleClickCancel = () => {
        props.setOpen(false)
    }

    const handleClickRevoke = () => {
        setLoading(true)
        revoke({ username: props.username }).then((response) => {
            if ("error" in response){
                dispatch(setNewNotification({
                    message: "Unable to revoke access. Please try again later.",
                    type: 'error'
                }))
            }
            else if ("data" in response){
                dispatch(setNewNotification({
                    message: "DUC access for " + response?.data?.username + " has been successfully revoked.",
                    type: 'success'
                }))
            }
            else{
                dispatch(setNewNotification({
                    message: "Unable to revoke access. Please try again later.",
                    type: 'error'
                }))
            }
            setLoading(false)
            props.setOpen(false)
        })

    }

    return (
        <LassoModal open={props.open}>
            {!loading && <Stack gap={4} padding={3}>

                <Typography variant="h5" fontWeight="600" color={colours.midnightBlue.blue} textAlign="center">
                        Revoke Access
                </Typography>
                <Stack gap={1}>
                    <Typography color={colours.midnightBlue.blue} textAlign="center">
                        Are you sure you want to revoke DUC access for:
                    </Typography>
                    <Typography color={colours.midnightBlue.blue} textAlign="center" fontWeight="600">
                        {props.username}
                    </Typography>

                </Stack>
                <Stack flexDirection="column" justifyContent="center" alignItems="center" gap={2}>
                    <Button variant="primary" onClick={handleClickRevoke} >
                        Confirm
                    </Button>
                    <Button size="small" variant="secondary" onClick={handleClickCancel} >
                        Cancel
                    </Button>
                </Stack>
            </Stack>}

            {loading &&
            <CircularProgress/>}

        </LassoModal>
    )
}
export default UserActionConfirm